import {jsx, css} from '@emotion/react';

const styles = {};

/*  App Logo */
styles.appLogoContainer = css`
  width: 74%;
  font-family: 'Oswald';
  text-transform: uppercase;
  display: flex;
  line-height: 22px;
  flex-direction: column;

  .appLogo {
    text-decoration: none;
    align-items: center;
    display: flex;

    &:hover {
      color: #333;
    }
  }

  h1 {
    font-size: 28px;
    margin-top: 0;
    margin-bottom: 0;

    @media(min-width: 768px) {
      font-size: 32px;
    }
  }

  @media print, (min-width: 768px) {
    width: 44%;
  }

  img {
    width: 50px;
    margin-right: 10px;
  }

  .logo-badge {
    background-color: #6D6D6D;
    border-radius: 4px;
    text-transform: uppercase;
    color: white;
    font-size: 11px;
    text-align: center;
    padding: 1px 5px 2px;
    margin-left: 0;
    margin-top: 25px;
    font-family: 'OCRoboto', sans-serif;
    line-height: 11px;

    @media print, (min-width: 1200px) {
      margin-left: 15px;
      margin-top: 20px;
    }
  }
`;

/* Menu */
styles.menu_container = css`
  margin: 20px auto 20px;
  max-width: none;

  @media print, (min-width: 768px) {
    display: flex;
  }

  @media(min-width: 1200px) {
    max-width: 1170px;
  }

  @media print {
    margin-bottom: 30px;
  }
`;

styles.menu_info_bar = css`
  width: auto;
  background: #EFEFEF;
  justify-content: flex-start;
  display: flex;
  list-style-type: none;
  margin: 10px -15px;
  padding: 10px 15px;
  position: relative;

  @media print, (min-width: 768px) {
    width: 56%;
    background: none;
    justify-content: flex-end;
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0 15px 0 0;

    @media(max-width: 768px) {
      &:nth-child(2) {
        margin-right: 0;
      }
    }

    @media (min-width: 768px) {
      margin: 0 15px 0 0;

      &:nth-child(2) {
        margin-right: 15px;
      }
    }

    @media print, (min-width: 1200px) {
      margin: 0 35px 0 0;

      &:nth-child(2) {
        margin-right: 35px;
      }
    }

    &:last-child {
      margin: 0;
    }

    a {
      text-decoration: none;
    }
  }

  .location {
    position: absolute;
    right: 15px;
    top: -50px;

    @media(min-width: 768px) {
      position: static;
    }

    @media print {
      display: none;
    }

    .zipChange {
      &:hover {
        cursor: pointer;
        color: #D40F7D;
      }
    }

    .result {
      display: inline-block;
    }

    .change {
      display: inline-block;
      padding-left: 5px;
      position: relative;
      top: -4px;

      i {
        font-size: 18px;
      }
    }
  }

  .heading {
    text-transform: uppercase;
    font-size: 11px;

    @media (min-width: 768px) {
      font-size: 12px;
    }

    @media print, (min-width: 1200px) {
      font-size: 14px;
    }
  }

  .result {
    text-transform: uppercase;
    font-size: 18px;
    font-family: 'Oswald';

    @media print, (min-width: 1200px) {
      font-size: 24px;
    }
  }
`;

/* Step Navigation */
styles.menu_navigation_container = css`
  max-width: none;
  position: fixed;
  bottom: 0;
  left: 0;
  background: black;
  padding: 15px;
  margin: 0;
  z-index: 1000;
  width: 100%;
  min-height: 65px;

  @media(min-width: 768px) {
    margin-bottom: 30px;
    position: relative;
    margin: 10px auto 30px;
    background: transparent;
    padding: 0;
    width: auto;
    min-height: auto;
  }

  @media(min-width: 1200px) {
    max-width: 1170px;
  }

  .stepContainer {
    @media(min-width: 768px) {
      -webkit-overflow-scrolling: touch;
      overflow-x: auto;
      overflow-y: hidden;
      &::-webkit-scrollbar { width: 0 !important }
      display: inline-block;
      width: 100%;
      height: 50px;
      margin-bottom: -15px;

      &:before {
        content: '';
        background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, white 75%);
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 1%;
        z-index: 1;
      }

      &:after {
        content: '';
        background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, white 75%);
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 120px;
        z-index: 1;
      }
    }

    @media(min-width: 1200px) {
      &:before, &:after {
        display: none;
      }
    }
  }

  @media print {
    display: none;
  }
`;

styles.menu_navigation = css`
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  white-space: nowrap;
  justify-content: center;

  @media(min-width: 768px) {
    justify-content: flex-start;
  }

  li {
    margin-bottom: 0;

    @media(min-width: 768px) {
      flex: auto;

      &:first-child {
        padding-left: 0;
      }
    }
  }

  .nextButtonContainer {
    display: none;

    @media(min-width: 768px) {
      display: block;
      padding-right: 35px;
      height: 34px;

      a, button {
        font-size: 16px;
        min-height: 34px;
        height: 34px;
      }
    }

    @media(min-width: 1200px) {
      padding-right: 0;
    }
  }
`;

styles.mobileOnly = css`
  @media(min-width: 768px) {
    display: none;
  }
`;

styles.disclaimers = css`
  font-size: 12px;
  border-top: 1px solid #BCBCBC;
  padding: 40px 0 20px;
  margin-top: 50px;

  @media print {
    margin-top: 10px;
    padding-top: 10px;
  }

  p {
    margin-bottom: 5px;
  }
`;

styles.withContractor = css`
  margin-top: 10px;
  font-size: 16px;
`

export default styles;
